var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMicrophone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_microphone@0.0x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "v4",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "B01",
    transform: "translate(-338.000000, -152.000000)",
    fill: "#51575C"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pop-up",
    transform: "translate(226.000000, 69.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "device",
    transform: "translate(112.000000, 76.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_microphone",
    transform: "translate(0.000000, 7.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.1545,7.58072722 C3.1545,10.1068272 5.4767,11.8751272 8,11.8751272 C10.5278,11.8751272 12.8454,10.1068272 12.8454,7.58072722 L12.8454,7.58072722 L14.4,7.58072722 C14.4,10.4563272 11.9128,12.8309272 8.9142,13.2392272 L8.9142,13.2392272 L8.9142,16.0012272 L7.0853,16.0012272 L7.0853,13.2393272 C4.0867,12.8307272 1.6,10.4563272 1.6,7.58072722 L1.6,7.58072722 Z M8,0.00222722115 C9.45477578,-0.0570377459 10.6824127,1.07369345 10.7427,2.52842722 L10.7427,2.52842722 L10.7335,7.58072722 C10.6745727,9.03236167 9.45176716,10.1623888 8,10.1068272 C6.54641092,10.1629672 5.32066173,9.03401941 5.2573,7.58072722 L5.2573,7.58072722 L5.2573,2.52842722 C5.31888507,1.0742952 6.54571747,-0.0556949613 8,0.00222722115 Z",
    id: "Combined-Shape"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrophone);
export default __webpack_public_path__ + "static/media/microphone.115aada50f8bcf04acf9a3a2f8b46bac.svg";
export { ForwardRef as ReactComponent };